import { useMutation, useQueryClient } from "@tanstack/react-query";
import { neWebApi } from "../../../../api";
import { neWebUrls } from "../../../../ne-web-urls";
import type { PPAInvoiceId } from "../PPAInvoicePage.types";

export function useGenerateInvoice() {
  const queryClient = useQueryClient();

  const generateInvoiceMutation = useMutation({
    mutationFn: (ppaInvoiceId: PPAInvoiceId) => generateInvoice(ppaInvoiceId),
    onSuccess: handleSuccess
  });

  async function handleSuccess() {
    await queryClient.invalidateQueries({
      queryKey: ["ppaDeliveryInvoices"]
    });
  }

  return { generateInvoiceMutation };
}

async function generateInvoice(ppaInvoiceId: PPAInvoiceId) {
  return neWebApi.post(neWebUrls.api.generateInvoice(), {
    unique_identifier: ppaInvoiceId
  });
}
